// extracted by mini-css-extract-plugin
export var footerSocialItem = "social-medias-module--footer-social-item--0c789";
export var footerSocialLinks = "social-medias-module--footer-social-links--4c9c1";